import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Form, Alert } from 'react-bootstrap';
import { MdAddchart } from 'react-icons/md';
import { FaAddressCard} from 'react-icons/fa';
import JoditEditor from 'jodit-react';
import './add-report.css';
import axios from 'axios';  // Import axios for making API requests
import { IoMdAddCircle } from "react-icons/io";
 
export default function AddReport() {
    const [startDate, setStartDate] = useState('');
    const [report, setReport] = useState('');
    const [isFormValid, setIsFormValid] = useState(true);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertVariant, setAlertVariant] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const navigate = useNavigate();
    const editor = useRef(null);
 
    // Get the user ID from localStorage (assuming user ID is stored here)
    const userId = localStorage.getItem('userId');  // Assuming 'userId' is stored in localStorage
    const name = localStorage.getItem('name');
    const username = localStorage.getItem('username');
 
    const handleFormSubmit = async (e) => {
        e.preventDefault();
 
        // Validate form
        if (!startDate || !report.trim()) {
            setIsFormValid(false);
            return;
        }
        setIsFormValid(true);
 
        // Prepare the data to be sent to the backend
        const reportData = {
            userId,
            username,
            name,
            reportingDate: startDate,
            reportingTime: new Date().toLocaleTimeString(), // Store current time as reporting time
            report
        };
 
        try {
            // Send a POST request to the backend to save the report
            const response = await axios.post('https://backend.ems.hiradentallab.com/api/reports/reports', reportData); // Update the endpoint URL as needed
            if (response.status === 201) {
                // Set success alert message
                setAlertMessage("Report added successfully!");
                setAlertVariant("success");
                setShowAlert(true);
                resetForm(); // Reset form fields after submission
 
                // Redirect after 3 seconds
                setTimeout(() => {
                    navigate('/my-work-reports'); // Navigate to the work report page
                }, 3000);
            }
        } catch (error) {
            // Handle error
            setAlertVariant("danger"); // Change alert type to danger
            if (error.response && error.response.data.message === "User already exists.") {
                setAlertMessage("Error: Report submission failed.");
            } else {
                setAlertMessage("Error adding report. Please try again.");
            }
            setShowAlert(true);
 
            // Set timeout to hide alert after 3 seconds
            setTimeout(() => {
                setShowAlert(false);
            }, 3000);
        }
    };
 
    const resetForm = () => {
        setStartDate('');
        setReport('');
    };
 
    const config = {
        // Add your JoditEditor configuration here if needed
    };
 
    return (
        <div className='add-report-container'>
            <section >
                <div className="main-box-upper">
                    <h1 className="title">
                    <IoMdAddCircle className="icons" />
                        Add Report
                    </h1>
                    <hr />
                </div>
            </section>
            <h1 className="subtitle">
            <FaAddressCard className="icons" />
                {name ? `${name}'s Work reports` : 'Welcome, Guest!'}
            </h1>
            <hr />
            <div className="form-container">
                <Form onSubmit={handleFormSubmit}>
                    <div className="form-box">
                            {/* Display alert message if present */}
                {showAlert && (
                    <Alert variant={alertVariant} className="mt-3">
                        {alertMessage}
                    </Alert>
                )}
                        <Col md={6}>
                            <Form.Group controlId="start_date">
                                <Form.Label>Start date <span className="required">*</span> :</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="start_date"
                                    className='date-picker'
                                    required
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <div className="mb-3">
                            <Form.Group controlId="reportEditor">
                                <Form.Label>Report:</Form.Label>
                                <JoditEditor
                                    ref={editor}
                                    value={report}
                                    config={config}
                                    tabIndex={1}
                                    onBlur={newContent => setReport(newContent)}
                                    className="editor"
                                />
                            </Form.Group>
                        </div>
                    </div>
                    <div className="form-actions">
                        <Button
                            variant='primary'
                            type="submit"
                            disabled={!startDate || !report.trim()}
                        >
                            <MdAddchart className="icon" />
                            Add
                        </Button>
                    </div>
                </Form>
                {!isFormValid && <p className="error-msg">Please fill out all required fields.</p>}
            </div>
        </div>
    );
}
 
 